import styled from 'styled-components';

import { AiDescriptionContainer } from 'adapter/in/common/components/AnalysisAiDescriptionView';

export const BOX_PADDING_TOP = 12;
export const BOX_PADDING_BOTTOM = 16;

export const Box = styled(AiDescriptionContainer)<{ $maxHeight?: number }>`
    padding: ${BOX_PADDING_TOP}px 16px ${BOX_PADDING_BOTTOM}px;
    ${({ $maxHeight }) => ($maxHeight ? `max-height: ${$maxHeight}px; overflow: hidden;` : '')}
`;
